/* jQuery COMPONENTS */

COMPONENTS.Equal = (function ($) {
  function Equal () {}

  Equal.prototype.width = function (jquerySelector) {
    let widest = 0
    $(jquerySelector).each(function () { widest = Math.max(widest, $(this).outerWidth()) }).css({ width: widest })
  }

  Equal.prototype.height = function (jquerySelector) {
    let tallest = 0
    $(jquerySelector).each(function () { tallest = Math.max(tallest, $(this).outerHeight()) }).css({ height: tallest })
  }

  return Equal
})(jQuery)

document.addEventListener('components_init', function () {
  // Hook into the main components init
  COMPONENTS.equalUtility = new COMPONENTS.Equal()
})
